import { ResponseResultTypeDecorator, GenericArrayServiceResponse } from '@nts/std';
import { ResponseCachedDecorator } from '@nts/std';
import { NodeChildrenDto } from '../domain-models/dto/node-children-dto';

@ResponseResultTypeDecorator(NodeChildrenDto)
@ResponseCachedDecorator()
export class GetChildrenFromNodeListResponse extends GenericArrayServiceResponse<NodeChildrenDto> {

}
